import { render, staticRenderFns } from "./TmplImport.vue?vue&type=template&id=454ea9ee"
import script from "./TmplImport.vue?vue&type=script&lang=js"
export * from "./TmplImport.vue?vue&type=script&lang=js"
import style0 from "./TmplImport.vue?vue&type=style&index=0&id=454ea9ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports